<div *transloco="let t; read: 'project-about'" class="project-about__container">
  <div class="project-about__header">
    <h2 class="kxi-text-medium kxi-text-600">{{ t('title', { item: title }) }}</h2>
  </div>

  <div class="project-about__content">
    @for (item of projectItemsToShow; track item) {
      <div class="project-about__content-item-wrapper">
        <div class="project-about__content-item-header">
          <h3 class="kxi-text-small kxi-text-600">{{ item.title }}</h3>
          <xi-icon [icon]="item.icon" [color]="item.iconColor" iconSize="large"></xi-icon>
        </div>
        <div class="project-about__content-text-container">
          <p>
            {{ item.description }}
          </p>
          <p>
            <a target="_blank" [href]="item.href">{{ item.linkText }}</a>
          </p>
        </div>
      </div>
    }
  </div>
</div>
